import { ref } from 'vue'

const isAppShellLoading = ref(false)
const appShellLoadingMessage = ref('Carregando aplicação...')

export const useAppShell = () => {
  const setLoading = (value: boolean, message = 'Carregando aplicação...') => {
    isAppShellLoading.value = value
    if (value) {
      appShellLoadingMessage.value = message
    }
  }

  return {
    isAppShellLoading,
    appShellLoadingMessage,
    setLoading
  }
}
